module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a12e5ce6042183e13ac302e565f0eaff.png";